module.exports = __webpack_public_path__ + "img/er.67f5cd29.svg";